import { render, staticRenderFns } from "./ChatMessageListItem.vue?vue&type=template&id=580a87dd&scoped=true&"
import script from "./ChatMessageListItem.vue?vue&type=script&lang=js&"
export * from "./ChatMessageListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageListItem.vue?vue&type=style&index=0&id=580a87dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a87dd",
  null
  
)

export default component.exports